import { IS_MAINTENANCE, MAINTENANCE_INFO } from '@/constants/constants'

export const useMaintenance = () => {
  return {
    isMaintenance: IS_MAINTENANCE,
    maintenanceMessage: MAINTENANCE_INFO,
  }
}
